import { render, staticRenderFns } from "./HospitalsList.vue?vue&type=template&id=724f045a&scoped=true&lang=pug"
import script from "./HospitalsList.vue?vue&type=script&lang=js"
export * from "./HospitalsList.vue?vue&type=script&lang=js"
import style0 from "./HospitalsList.vue?vue&type=style&index=0&id=724f045a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724f045a",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Icon: require('/home/docker/code/frontend/components/Icon.vue').default,Address: require('/home/docker/code/frontend/components/Address.vue').default})
